import React from 'react';
import { formatFileSize, getFileIcon } from '../../../utilities/fileUtils';

export interface AIReadOnlyFileListItem {
    id: string;
    fileName: string;
    fileSize: number;
}

interface AIReadOnlyFileListProps {
    files: AIReadOnlyFileListItem[];
    renderAction?: (file: AIReadOnlyFileListItem) => React.ReactNode;
}

export const AIReadOnlyFileList: React.FC<AIReadOnlyFileListProps> = ({
    files,
    renderAction
}) => (
    <div className="ai-imported-files-list">
        {files.map(file => (
            <div key={file.id} className="ai-imported-file-item">
                <i className={`glyphicon ${getFileIcon(file.fileName)}`} aria-hidden="true"></i>
                <span className="ai-imported-file-name">{file.fileName}</span>
                <span className="ai-imported-file-size">{formatFileSize(file.fileSize)}</span>
                {renderAction?.(file)}
            </div>
        ))}
    </div>
);

export default AIReadOnlyFileList;
